import { render, staticRenderFns } from "./user_match.vue?vue&type=template&id=442dc9dc&scoped=true"
import script from "./user_match.vue?vue&type=script&lang=ts"
export * from "./user_match.vue?vue&type=script&lang=ts"
import style0 from "./user_match.vue?vue&type=style&index=0&id=442dc9dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442dc9dc",
  null
  
)

export default component.exports